import { UIThemeProvider } from '@rbx/ui';
import { useFoundationTheme } from '@rbx/foundation-ui';
import React, { FunctionComponent, useState, useEffect } from 'react';
import { useThemeMode } from '@rbx/settings';

const ModeResponsiveThemeProvider: FunctionComponent<
  React.PropsWithChildren<{ themeElement?: HTMLElement }>
> = ({ themeElement, children }) => {
  const [theme, setTheme] = useState<'dark' | 'light'>('dark');
  const { themeMode } = useThemeMode();
  useFoundationTheme(themeMode, themeElement);
  // need a force reload to update the theme to resolve the issue in CRF-4636
  // with this useEffect, it can remove the NoSSR tags added in pull/612
  useEffect(() => {
    setTheme(themeMode);
  }, [themeMode]);
  return <UIThemeProvider theme={theme}>{children}</UIThemeProvider>;
};

export default ModeResponsiveThemeProvider;
